import TakeCare from './TakeCare'

export default TakeCare
